import styled from 'styled-components';

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 4px;
  font-size: 16px;
  background-color: ${p => p.theme.colors.gray2};
`;

export const FileInputLabel = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 82px;
  height: auto;
  padding: 5px;
  box-sizing: border-box;
  gap: 5px;
  background-color: var(--HPACS_BG_grey, #f5f5f5);
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  cursor: pointer;
  min-width: 0;

  ${p => p.theme.isMobile && 'min-height: auto;'}
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileItemNameContainer = styled.div`
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const FileItemName = styled.span`
  vertical-align: middle;
`;

export const ImageWrapper = styled.div`
  margin-left: auto;
`;
